export const getRelativeUrlWithSearchParams = (
  urlString: string,
  params: Record<string, string>,
): string => {
  const url = new URL(urlString, window.location.origin);

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value);
    }
  });

  return url.pathname + url.search;
};
